<!--
 * @Author: 曹捷
 * @Date: 2019-08-01 14:25:14
 * @LastEditors: 曹捷
 * @LastEditTime: 2021-10-21 19:08:56
 * @Description: file content
 -->
<template>
  <div class="errPage-container">
    <obit-button @click="$router.push({ path: '/' })" type="org" :animation="'line-top-bottom'">回首页</obit-button>
    <a-row>
      <a-col :span="12">
        <h1 class="text-jumbo text-ginormous">Oops!</h1>
        <h2>你没有权限去该页面</h2>
        <h6>如有不满请联系你领导</h6>
        <ul class="list-unstyled">
          <li>或者你可以去:</li>
          <li class="link-type">
            <a @click="back" href>返回</a>
          </li>
          <li class="link-type">
            <a @click="toLogin">重新登录</a>
          </li>
        </ul>
      </a-col>
      <a-col :span="12">
        <img src="@/assets/401_images/401.gif" alt="Girl has dropped her ice cream." height="428" width="313" />
      </a-col>
    </a-row>
    <!-- <el-dialog :visible.sync="dialogVisible" title="随便看">
      <img :src="ewizardClap" class="pan-img" />
    </el-dialog> -->
  </div>
</template>

<script>
import { logout } from 'obit-wui/utils/auth'
export default {
  name: 'Page401',
  data () {
    return {
      dialogVisible: false
    }
  },
  methods: {
    back () {
      if (this.$route.query.noGoBack) {
        this.$router.push({ path: '/main' })
      } else {
        this.$router.go(-1)
      }
    },
    toLogin () {
      logout(this.$router)
    }
  }
}
</script>

<style lang="less"  >
.errPage-container {
  width: 800px;
  max-width: 100%;
  margin: 100px auto;
  .pan-back-btn {
    background: #008489;
    color: #fff;
    border: none !important;
  }
  .pan-gif {
    margin: 0 auto;
    display: block;
  }
  .pan-img {
    display: block;
    margin: 0 auto;
    width: 100%;
  }
  .text-jumbo {
    font-size: 60px;
    font-weight: 700;
    color: #484848;
  }
  .list-unstyled {
    font-size: 14px;
    li {
      padding-bottom: 5px;
    }
    a {
      color: #008489;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
